import { getTitleStyle } from '@upright/ui/common/generic/content/texts/bou-title/title-style';
import styled from 'styled-components';
import { getRenderViewItemNameMaybe } from '../../utils';
import { RenderItem } from '@upright/common/renderer/types';

export const RenderViewTitleMaybe = (props: {
  params: { item: RenderItem; chartTitle?: string; hideTitle?: boolean };
  defaultTitle?: string;
}) => {
  const { params } = props;
  if (params.hideTitle) return <></>;
  return (
    <TitleContainer>
      <h4>{params.chartTitle || props.defaultTitle || getRenderViewItemNameMaybe(params)}</h4>
    </TitleContainer>
  );
};
const TitleContainer = styled.div`
  display: flex;
  margin-left: 2em;
  h4 {
    ${getTitleStyle({ size: 'h4' })}
    margin-bottom: 0.5em;
  }
`;
